export default {
  CaregiverMatchingStep: {
    RequestProfilesButton: 'Finish',
  },
  NextStepsSection: {
    Title: 'Next Steps',
    ReviewTitle: 'Caregiver profile review',
    ReviewSubtitle: 'Within 3-5 days',
    MeetTitle: 'Meet & greet',
    StartTitle: 'Start date',
    DateNotSet: 'Date not set',
  },
  WhatHappensCard: {
    Title: 'What happens next',
    DescriptionLine1: 'The right fit, for the long run. You will find a caregiver match with the right skills, availability, and personality for your loved one.',
    DescriptionLine2: 'We will send you caregiver profiles to review.',
  },
  WorksCard: {
    Title: 'Why this works',
    Description: 'Our "mutual opt-in" approach means your caregivers have chosen your family as much as you\'ve chosen them, fostering a deep bond of trust and consistency from day one.',
  },
  SmsOptInCard: {
    Title: 'Care Messaging',
    PrimaryDisclosure: 'By checking this box, you agree to receive SMS messages from CareQuilt at the phone number you provided#{clientPhoneNumber}. These messages may include care coordination, appointment updates, and support-related communications between you and your assigned caregiver. Message frequency varies. Message and data rates may apply.',
    ReplyActionsBeforePrivacy: 'Reply STOP to opt out at any time. Reply HELP for help or contact support@carequilt.ca. See our ',
    PrivacyLinkLabel: 'Privacy Policy',
    And: ' and ',
    TermsLinkLabel: 'Terms & Conditions',
    ReplyActionsAfterTerms: '.',
    AgreeStatement: 'I agree to receive SMS messages from CareQuilt',
  },
};
